var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48749 13C7.43745 13 7.36239 12.976 7.33737 12.952C7.08717 12.7601 1.58276 8.131 0.43184 5.75646C-0.0685611 4.72509 -0.143621 3.50185 0.256699 2.42251C0.60698 1.51107 1.2575 0.791513 2.10818 0.407749C2.68364 0.143911 3.33416 0 3.98468 0C5.43585 0 6.76191 0.671587 7.38741 1.70295L7.46247 1.84686L7.56255 1.70295C8.21307 0.671587 9.56415 0 11.0153 0C11.6658 0 12.3164 0.143911 12.8918 0.407749C13.7425 0.791513 14.393 1.51107 14.7433 2.42251C15.1436 3.47786 15.0686 4.72509 14.5682 5.75646C13.4172 8.08303 8.01291 12.6642 7.68765 12.928C7.63761 12.976 7.58757 13 7.53753 13C7.51251 13 7.51251 13 7.48749 13Z",
    fill: "#CD2626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeRed);
export default __webpack_public_path__ + "static/media/like-red.2a5399a21a66b02e97551a32b779409b.svg";
export { ForwardRef as ReactComponent };